import { ColumnModel } from './column.model';
import { FilterModel } from './filter.model';
import { OrderModel } from './order.model';

export class ExportModel {
    action: string;
    filters: FilterModel[];
    columns: ColumnModel[];    
    order: OrderModel;
}